import React from "react";
import { getAuth, isNullUndefinedOrEmpty, removeAuth } from "../../common/Helpers";

function AuthVerify(props) {

    if (window.location.href.indexOf("/login") === -1) {
        const cookieSg3Plus = getAuth();

        if (isNullUndefinedOrEmpty(cookieSg3Plus)) {
            removeAuth();
            window.location.href = "/login"
        }
    }

    return (<></>);
}

export default AuthVerify;


